import { Record } from "immutable";
import type { RecordOf } from "immutable";
import { makeModifier, type Modifier } from "../pageModifiers/reducer";
import { SET_MODIFIER_FORM_FIELDS, SET_MODIFIER_FORM_IS_EXPAND } from "../../helpers/constants";
import type {
  Actions,
  SetModifierFormIsExpandAction,
  SetModifierFormFieldsAction,
} from "../../actions/modifierForm";

export type DefaultStateType = {
  data: ReturnType<typeof makeModifier>,
  isExpand: boolean,
}

const DefaultState: DefaultStateType = {
  data: makeModifier({ name: "", description: "", type: "textarea" }),
  isExpand: false,
};

export type State = RecordOf<DefaultStateType>;

export const makeState = Record(DefaultState);

export const initialState: State = makeState();

export function initModifierFormState(): State {
  return initialState;
}

// eslint-disable-next-line default-param-last
const modifierFormReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_MODIFIER_FORM_IS_EXPAND: {
      const { value } = action as SetModifierFormIsExpandAction;
      return state.set("isExpand", value);
    }
    case SET_MODIFIER_FORM_FIELDS: {
      const { data } = action as SetModifierFormFieldsAction;
      return state.set("data", state.get("data").merge(data));
    }
    default:
      return state;
  }
};

export default modifierFormReducer;
